/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMoneyInBanksInput
 */
export interface GetMoneyInBanksInput {
    /**
     * Comma separated string of ISO Alpha-2 country codes.
     * Available country codes include: 
     * <ul><li> France (FR) </li><li>Spain (ES) </li><li> Italy (IT)</li><li> Germany (DE)</li><li> United Kingdom (GB) </li><li> Portugal (PT)</li><li> Sweden (SE)</li></ul>
     * @type {string}
     * @memberof GetMoneyInBanksInput
     */
    countryCodes?: string;
}

/**
 * Check if a given object implements the GetMoneyInBanksInput interface.
 */
export function instanceOfGetMoneyInBanksInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMoneyInBanksInputFromJSON(json: any): GetMoneyInBanksInput {
    return GetMoneyInBanksInputFromJSONTyped(json, false);
}

export function GetMoneyInBanksInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyInBanksInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countryCodes': !exists(json, 'countryCodes') ? undefined : json['countryCodes'],
    };
}

export function GetMoneyInBanksInputToJSON(value?: GetMoneyInBanksInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countryCodes': value.countryCodes,
    };
}

